<div
  class="pop-up-main-container"
  [ngStyle]="
    styleService.getStyleRule(
      undefined,
      [welcomePopUp?.background],
      [welcomePopUp?.border]
    )
  "  
>
  <h1
    *ngIf="!welcomePopUp.checkForErrors"
    [ngStyle]="
      styleService.getStyleRule([
        welcomePopUp.messageStyle,
        undefined,
        'heading1'
      ])
    "
  >
    {{
      welcomePopUp?.message
        ? (welcomePopUp.message
          | conditionalUppercase
            : styleService.getUppercaseValue(welcomePopUp.messageStyle))
        : "PopUp message"
    }}
  </h1>
  <h3 
    *ngIf="welcomePopUp.checkForErrors" 
    [ngStyle]="
      styleService.getStyleRule([
        welcomePopUp.messageStyle,
        undefined,
        'heading1'
      ])
    "
    [innerHTML]="formatErrorMessage(welcomePopUp.message, welcomePopUp.errors)"
  >
  </h3>

  <div class="button-container">
    <button
      *ngIf="welcomePopUp?.showGoToProfile"
      (click)="goToProfile()"
      [ngStyle]="
        styleService.getStyleRule(
          [welcomePopUp?.addButton?.text],
          [welcomePopUp?.addButton?.background],
          [welcomePopUp?.addButton?.border]
        )
      "
    >
      {{
        welcomePopUp?.addButtonText
          ? (welcomePopUp.addButtonText
            | conditionalUppercase
              : styleService.getUppercaseValue(welcomePopUp.button.text))
          : "Add Now"
      }}
    </button>
    <button
      (click)="closePopUp()"
      [ngStyle]="
        styleService.getStyleRule(
          [welcomePopUp?.button?.text],
          [welcomePopUp?.button?.background],
          [welcomePopUp?.button?.border]
        )
      "
    >
      {{
        welcomePopUp?.buttonText
          ? (welcomePopUp.buttonText
            | conditionalUppercase
              : styleService.getUppercaseValue(welcomePopUp.button.text))
          : "Close button"
      }}
    </button>
  </div>
</div>
